import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { UserService } from "@common/user/user.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { EMPTY } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { CatchupView } from "../catchup-views";
import { PeerCatchupAuthService } from "../peer-catchup-auth.service";
import { PeerCatchupUiService } from "../peer-catchup-ui.service";

@Component({
    selector: "adapt-catchups-page-content",
    templateUrl: "./catchups-page-content.component.html",
    standalone: false,
})
export class CatchupsPageContentComponent extends BaseComponent implements OnChanges {
    @Input() public person?: Person;
    @Input() public team?: Team;

    public readonly CatchupView = CatchupView;
    public graphOptions: any;
    public viewSelection = CatchupView.Graph;

    public canEditPerson = false;
    public canEditMyCatchup = false;

    constructor(
        private userService: UserService,
        private peerCatchupAuthService: PeerCatchupAuthService,
        private peerCatchupUiService: PeerCatchupUiService,
    ) {
        super();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.person && this.person) {
            this.peerCatchupAuthService.canEditCatchupsForPerson(this.person).pipe(
                this.takeUntilDestroyed(),
            ).subscribe((canEdit) => {
                this.canEditPerson = canEdit;
            });
        } else if (changes.team && this.team) {
            this.peerCatchupAuthService.canEditPersonalCatchups.pipe(
                this.takeUntilDestroyed(),
            ).subscribe((canEdit) => this.canEditMyCatchup = canEdit);
        }
    }

    @Autobind
    public recordPersonCatchup() {
        if (this.person) {
            return this.peerCatchupUiService.recordNewCatchup(this.person.personId);
        } else {
            return EMPTY;
        }
    }

    @Autobind
    public recordTeamCatchup() {
        if (this.team) {
            return this.userService.currentPerson$.pipe(
                take(1),
                switchMap((person) => this.peerCatchupUiService.recordNewCatchup(person!.personId, undefined, this.team!.teamId)),
            );
        } else {
            return EMPTY;
        }
    }
}
